class NavigationObserver {
    constructor(uid, history, process) {
        this.uid = uid;
        this.history = history;
        this.process = process;
    }

    check(location, action) {
        if (!this.forbid || this.forbid(location, action, this.history.location)) {
            return false;
        }
    }

    when(filter) {
        this.forbid = filter;

        return this;
    }
}

class NavigationBlocker {
    off = null;

    constructor() {
        this.observers = {};
    }

    subscribe(history, uid, observer) {
        if (!this.off) {
            this.off = history.block((location, action) => {
                for (const [uid, observer] of Object.entries(this.observers)) {
                    if (false === observer.check(location, action)) {
                        return uid;
                    }
                }
            });
        }

        return (this.observers[uid] = new NavigationObserver(uid, history, observer));
    }

    unsubscribe(uid) {
        const observer = this.observers[uid];

        if (observer) {
            delete this.observers[uid];

            if (!Object.keys(this.observers).length) {
                this.off();
                this.off = null;
            }
        }
    }

    notify(uid, callback) {
        const observer = this.observers[uid];

        if (observer) {
            observer.process(callback);
        }

        return !!observer;
    }
}

export default new NavigationBlocker();
